import { formatMeasurementValue, type MeasurementType } from "@/lib/geometry";

import { normalizeFieldPilotProgressMode } from "@/features/field-pilot/progress-row-actions-menu";

export function measurementTypeByTagIdFromItems(
  items: ReadonlyArray<{
    tagId: { toString(): string } | string;
    archivedAt?: number;
    measurementType?: MeasurementType | null;
  }>
): Map<string, MeasurementType> {
  const map = new Map<string, MeasurementType>();
  for (const item of items) {
    if (item.archivedAt || !item.measurementType || map.has(String(item.tagId))) continue;
    map.set(String(item.tagId), item.measurementType);
  }
  return map;
}

export function formatProgressValue(
  value: number,
  row: { progressMode: string; measurementType: MeasurementType | null }
): string {
  if (normalizeFieldPilotProgressMode(row.progressMode) === "measurement_value") {
    if (row.measurementType) {
      return `${formatMeasurementValue(value, row.measurementType)} ${row.measurementType}`;
    }
    return value.toLocaleString();
  }
  return `${value.toLocaleString()} count${value === 1 ? "" : "s"}`;
}
